import React from 'react'
import { Text } from '../../components/ui'
import { PAGE_SIZE, PAGINATION_BTN_CLASS } from './estoqueUi'

type Props = {
  page: number
  total: number
  onPageChange: (page: number) => void
  pageSize?: number
}

const EstoquePagination: React.FC<Props> = ({
  page,
  total,
  onPageChange,
  pageSize = PAGE_SIZE,
}) => {
  if (total <= pageSize) return null

  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const pageSafe = Math.min(page, totalPages)
  const from = (pageSafe - 1) * pageSize + 1
  const to = Math.min(pageSafe * pageSize, total)

  return (
    <div className="mt-4 flex items-center justify-between text-sm text-gray-700 dark:text-gray-300">
      <Text size="sm">
        Mostrando {from} a {to} de {total}
      </Text>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={pageSafe <= 1}
          onClick={() => onPageChange(Math.max(1, pageSafe - 1))}
          className={PAGINATION_BTN_CLASS}
        >
          Anterior
        </button>
        <button
          type="button"
          disabled={pageSafe >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, pageSafe + 1))}
          className={PAGINATION_BTN_CLASS}
        >
          Próximo
        </button>
      </div>
    </div>
  )
}

export default EstoquePagination
